//
// ReportRendererSetup.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./MediaType";

var ReportRendererSetup = createModule("transport::ReportRendererSetup", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel","transport::MediaType"], EventDispatcher, [
    ,
    ,
    ,
    ,
    ,
    ,
    ,
]);
export default ReportRendererSetup;
